declare const google;
import * as _ from "lodash";
import * as angular from "angular";
import { EventHelper } from "../event/event.helper";

let MapFormElementComponent = {
    selector: "vcMapFormElement",
    templateUrl: "/angular/components/map/map-form-element.component.html",
    bindings: {
        location: "=?",
    },
    controller: class MapFormElementController {
        // * bindings for typescript compiler *
        public location?: any;
        // ************************************

        private readonly $scope: any;
        private uiGmapGoogleMapApi: any;
        private uiGmapIsReady: any;
        private readonly eventHelper: EventHelper;

        public showMap = false;
        public initPinLocation: boolean;
        public options: any = {};
        public locating: boolean;
        public locationError: string | null;
        public originalMarker: any = null;
        public map: any;
        public elementMarker: any;
        public markerEvents: any;
        public address_changed: boolean;

        constructor(
            $scope: any,
            $timeout: any,
            uiGmapGoogleMapApi: any,
            uiGmapIsReady: any,
            EventHelper: EventHelper
        ) {
            this.$scope = $scope;
            this.uiGmapGoogleMapApi = uiGmapGoogleMapApi;
            this.uiGmapIsReady = uiGmapIsReady;
            this.eventHelper = EventHelper;

            $timeout(() => {
                this.showMap = true;
            }, 500);
        }

        $onInit() {
            this.initPinLocation = !(
                this.location &&
                this.location.latitude &&
                this.location.longitude
            );

            let timeoutCode: any;
            let delayInMs = 500;
            let findingReverseGeocodingAddress = false;

            this.$scope.$watch(
                () => (this.location ? this.location.address : undefined),
                (newValue: string, oldValue: string | undefined) => {
                    if (
                        !oldValue &&
                        this.location &&
                        (this.location.latitude || this.location.latitude)
                    ) {
                        this.initialiseMarker();
                    } else if (!findingReverseGeocodingAddress && newValue) {
                        clearTimeout(timeoutCode); //does nothing, if timeout already done
                        timeoutCode = setTimeout(() => {
                            if (!this.locating && newValue !== oldValue) {
                                this.locate();
                            }
                        }, delayInMs);
                    }
                },
                true
            );

            _.merge(this.options, {
                locateMarker: (location: any): void => {
                    this.address_changed = true;
                    this.updateLocationCoords();
                    this.elementMarker = {
                        id: 1,
                        locationtype: location.locationtype,
                        coords: location.coords,
                        options: {
                            title: "Suggested Location",
                            draggable: true,
                            icon: "/img/map/markers/events.png",
                        },
                    };
                    this.setMapCenter();
                },
                checkForNewLocationCoords: (): object | null => {
                    if (this.address_changed) {
                        return this.elementMarker;
                    }
                    return null;
                },
            });
        }

        locate(): void {
            this.locationError = null;
            this.locating = true;
            this.eventHelper.locate(
                { haddress: this.location.address },
                (location: any) => {
                    this.locating = false;
                    if (
                        this.location.latitude != location.coords.latitude ||
                        this.location.longitude != location.coords.longitude
                    ) {
                        this.options.locateMarker(location);
                        this.location.latitude = location.coords.latitude;
                        this.location.longitude = location.coords.longitude;
                    }
                },
                (error: object) => {
                    this.locating = false;
                    if (error["hlocationtype"] === "ZERO_RESULTS") {
                        this.locationError =
                            "Could not find coordinates for that address.";
                    } else {
                        this.locationError =
                            "Could not connect to Google Maps right now";
                    }
                }
            );
        }

        loadMap(): void {
            this.uiGmapGoogleMapApi.then(() => {
                this.map = {
                    bounds: {},
                    center: {
                        latitude: 0,
                        longitude: 0,
                    },
                    zoom: 1,
                    control: {},
                };

                this.elementMarker = {
                    id: 1,
                    coords: {
                        latitude: 0,
                        longitude: 0,
                    },
                    options: {
                        draggable: true,
                        icon: "/img/map/markers/events.png",
                    },
                };

                this.markerEvents = {
                    dragstart: () => {
                        this.pinDragged();
                    },
                    dragend: () => {
                        this.updateLocationCoords();
                    },
                };
                this.initialiseMarker();
                this.uiGmapIsReady.promise().then(() => {});
            });
        }

        initialiseMarker(): void {
            this.originalMarker = null;
            if (this.location) {
                this.location.latitude = this.location.latitude || 0;
                this.location.longitude = this.location.longitude || 0;
                this.elementMarker = {
                    id: 1,
                    coords: {
                        latitude: this.location.latitude,
                        longitude: this.location.longitude,
                    },
                    options: {
                        draggable: true,
                        icon: "/img/map/markers/events.png",
                    },
                };
            }
            this.setMapCenter();
        }

        setMapCenter(): void {
            // no markers anywhere show the world
            if (!this.elementMarker && !this.originalMarker) {
                this.map.center = {
                    latitude: 0,
                    longitude: 0,
                };
                this.map.zoom = 1;
            }
            // both markers calculate bounds
            else if (this.elementMarker && this.originalMarker) {
                let bounds = new google.maps.LatLngBounds();
                let glatlng1 = new google.maps.LatLng(
                    this.elementMarker.coords.latitude,
                    this.elementMarker.coords.longitude
                );
                bounds.extend(glatlng1);
                let glatlng2 = new google.maps.LatLng(
                    this.originalMarker.coords.latitude,
                    this.originalMarker.coords.longitude
                );
                bounds.extend(glatlng2);
                this.map.bounds = {
                    southwest: {
                        latitude: bounds.getSouthWest().lat(),
                        longitude: bounds.getSouthWest().lng(),
                    },
                    northeast: {
                        latitude: bounds.getNorthEast().lat(),
                        longitude: bounds.getNorthEast().lng(),
                    },
                };
            } else if (
                this.elementMarker &&
                this.elementMarker.coords.latitude != 0 &&
                this.elementMarker.coords.longitude != 0
            ) {
                this.map.center = _.cloneDeep(this.elementMarker.coords);
                this.map.zoom = 16;
            } else if (this.originalMarker) {
                this.map.center = _.cloneDeep(this.originalMarker.coords);
                this.map.zoom = 16;
            }
        }

        pinDragged(): void {
            this.address_changed = true;
            this.updateLocationCoords();
        }

        resetMarker(): void {
            this.address_changed = false;
            this.initialiseMarker();
        }

        updateLocationCoords(): void {
            this.location.longitude = this.elementMarker.coords.longitude;
            this.location.latitude = this.elementMarker.coords.latitude;
        }
    },
};

angular
    // .module("map", ["uiGmapgoogle-maps", "boundsService"])
    .module("map")
    .component(MapFormElementComponent.selector, MapFormElementComponent);
